import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule} from '../material/material.module';
import { DialogWithCloseButtonComponent } from './dialog-with-close-button/dialog-with-close-button.component';



@NgModule({
  declarations: [DialogWithCloseButtonComponent],
  imports: [
    CommonModule,
    MaterialModule
  ],
  exports: [DialogWithCloseButtonComponent]
})
export class UtilsModule { }
